(() => {
  if (window.__wdCartPageInit) return;
  window.__wdCartPageInit = true;

  const CART_PAGE_SECTIONS = ["main-cart-items", "main-cart-footer", "main-cart-shipping"];

  function getBasePath() {
    return (window.Shopify?.routes?.root || "/").replace(/\/?$/, "/");
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(n, max));
  }

  function triggerDiscountRecalc() {
    // Dit is jouw "start recalculating" hook
    document.documentElement.classList.add("wd-calculating-discount");
  }

  function refreshTrustpilot() {
    // Veilig: alleen als Trustpilot aanwezig is
    try {
      const tp = window.Trustpilot;
      if (!tp || typeof tp.loadFromElement !== "function") return;

      document.querySelectorAll(".trustpilot-widget").forEach((el) => {
        tp.loadFromElement(el, true);
      });
    } catch (_) {}
  }

  async function refreshCartPageUI({ preserveScroll = true } = {}) {
    const base = getBasePath();

    // ✅ behoud page scroll (mobile vooral belangrijk)
    const prevY = preserveScroll ? (window.scrollY || window.pageYOffset || 0) : 0;

    const url =
      base +
      "?sections=" +
      encodeURIComponent(CART_PAGE_SECTIONS.join(",")) +
      "&sections_url=" +
      encodeURIComponent(window.location.pathname);

    const res = await fetch(url, { cache: "no-store", credentials: "same-origin" });
    if (!res.ok) return;

    const sections = await res.json();

    CART_PAGE_SECTIONS.forEach((id) => {
      const html = sections[id];
      if (!html) return;

      const doc = new DOMParser().parseFromString(html, "text/html");
      const fresh = doc.getElementById(id);
      const current = document.getElementById(id);

      if (fresh && current) current.replaceWith(fresh);
    });

    // ✅ restore scroll (met clamp)
    if (preserveScroll) {
      const restore = () => {
        const max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        window.scrollTo(0, clamp(prevY, 0, max));
      };
      requestAnimationFrame(restore);
      setTimeout(restore, 80);
      setTimeout(restore, 220);
    }

    refreshTrustpilot();
  }

  // ---- Upsell add (cart page) ----
  async function addVariantToCart(variantId) {
    const base = getBasePath();

    const res = await fetch(base + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
      }),
    });

    if (!res.ok) {
      // fail silently, maar je kunt hier console loggen als je wil
      return;
    }
  }

  // ---- Debounced refresh cycle (snel + “late” refresh voor discount) ----
  let t1 = null;
  let t2 = null;
  let inFlight = false;

  async function runRefreshCycle() {
    if (inFlight) return;
    inFlight = true;
    try {
      await refreshCartPageUI({ preserveScroll: true });
    } finally {
      inFlight = false;
    }
  }

  function scheduleRefreshCycle() {
    triggerDiscountRecalc();

    if (t1) clearTimeout(t1);
    if (t2) clearTimeout(t2);

    // 1) snelle refresh
    t1 = setTimeout(runRefreshCycle, 250);

    // 2) late refresh (voor “discount komt na paar sec” situaties)
    t2 = setTimeout(runRefreshCycle, 2600);
  }

  // ---- Catch upsell clicks ----
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".js-upsell-add");
    if (!btn) return;

    const variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;

    btn.disabled = true;

    try {
      triggerDiscountRecalc();
      await addVariantToCart(variantId);
      scheduleRefreshCycle();
    } finally {
      btn.disabled = false;
    }
  });

  // ---- Catch all cart changes (remove/qty/update) by sniffing fetch ----
  if (!window.__wdCartFetchPatched) {
    window.__wdCartFetchPatched = true;

    const origFetch = window.fetch.bind(window);
    window.fetch = async (...args) => {
      const res = await origFetch(...args);

      try {
        const input = args[0];
        const url = typeof input === "string" ? input : input?.url || "";
        const isCartCall =
          typeof url === "string" &&
          (url.includes("/cart/change") ||
            url.includes("/cart/update") ||
            url.includes("/cart/add"));

        if (isCartCall) scheduleRefreshCycle();
      } catch (_) {}

      return res;
    };
  }

  // Eerste run (handig als iemand landt op /cart met al bundles)
  scheduleRefreshCycle();
})();
